import { render, staticRenderFns } from "./match2022p.vue?vue&type=template&id=320125be&scoped=true"
import script from "./match2022p.vue?vue&type=script&lang=js"
export * from "./match2022p.vue?vue&type=script&lang=js"
import style0 from "./match2022p.vue?vue&type=style&index=0&id=320125be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320125be",
  null
  
)

export default component.exports